import { z } from "zod";

export const consent = z.object({
  id: z.string(),
  consentTitle: z.string(),
  consentText: z.string(),
  consentLongText: z.string(),
  consentVersion: z.number(),
  activeFrom: z.string(),
});

export const serverResponse = z.array(consent);
export type IConsent = z.infer<typeof consent>;
